import type { IconProps, Icon as IconType } from "react-feather";

/**
 * A wrapper around Feather icons to apply some default styling.
 */
export function Icon({
	icon: Icon,
	...rest
}: {
	icon: IconType;
} & IconProps) {
	return <Icon {...rest} size="1.4em" />;
}
